'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import React, { useEffect } from 'react'
import { atom, useRecoilState } from 'recoil'

import { browserIdState } from '@/components/Context/BrowserProvider'
import { createImpression } from '@/serverActions/createImpression'

export const impressionIdState = atom<string | null>({
  key: 'impressionId',
  default: null,
})

export default function ImpressionProvider() {
  const [browserId] = useRecoilState(browserIdState)
  const pathname = usePathname()
  const searchParams = useSearchParams()

  // eslint-disable-next-line no-unused-vars
  const [impressionId, setImpressionId] = useRecoilState(impressionIdState)
  useEffect(() => {
    if (browserId) {
      const queryString = searchParams.toString()
      // NOTE: /line/liff 以下のページは パラメータ制御が難しいので、browsing=1 を常に付与する。
      const newQueryString =
        impressionId != null || pathname.startsWith('/line/liff') ? `browsing=1&${queryString}` : queryString
      createImpression(pathname, newQueryString).then((impressionId) => {
        setImpressionId(impressionId)
      })
    }
  }, [browserId, pathname, searchParams])

  return <></>
}
